 <template>
  <div id="app">
    <!-- Navigation-->
    <nav class="navbar navbar-expand-lg navbar-dark bg-default fixed-top" id="mainNav">
      <b-button 
        v-b-toggle.menuCollapsed 
        class="navbar-toggler navbar-toggler-right"
        >
        <span class="navbar-toggler-icon"></span>
      </b-button >
        
      <b-collapse id="menuCollapsed" class="navbar-collapse o-hidden">

        <h2 class="color-white">Corretor</h2>

        <h3 class="color-white" style="margin-left: 3%; margin-bottom: 3px;">{{ nomeUsuario }}</h3>

        <ul class="navbar-nav navbar-sidenav">
          
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard">
            <router-link class="nav-link" to="/corretor/dashboard">
              <i class="fa fa-fw fa-dashboard"></i>
              <span class="nav-link-text"> Dashboard</span>
            </router-link>
          </li>
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Oportunidades">
            <router-link class="nav-link" to="/corretor/oportunidades">
              <i class="fa fa-fw fa-info"></i>
              <span class="nav-link-text"> Oportunidades</span>
            </router-link>
          </li>
           <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Vendas">
            <router-link class="nav-link" to="/corretor/vendas">
              <i class="fa fa-fw fa-usd"></i>
              <span class="nav-link-text"> Vendas</span>
            </router-link>
          </li>  

        </ul>

        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" @click="logOut();">
              <i class="fa fa-fw fa-sign-out"></i>Logout
            </a>
          </li>
        </ul>
      </b-collapse>
    </nav>
    <!-- /Navigation-->


    <!-- Conteudo-->
    <router-view />
    <!-- /Conteudo-->

  </div>
</template>
<script>
import { verificaSeEstaLogado } from "../../utils/util";

export default {
  data() {
    return {
      logado: false,
      nomeUsuario: '',
      collapseMenu: false,
      classMenu: 'navbar-collapse collapse',
    };
  },
  mounted() {
    var self = this;
    var user = verificaSeEstaLogado();
    if(user){
      self.logado = true;
      self.nomeUsuario = user.name;
    }else{
      self.logado = false;
    }
  },
  methods: {
      logOut(){
        localStorage.removeItem("token_adm_comprodonto");
        this.$router.push('/')
      }
    },
}
</script>
<style scoped>

@media (min-width: 992px){
  #mainNav.fixed-top .navbar-sidenav {
      height: calc(100vh);
  }
}
</style>
